import React from "react";
import Button from "../ui/Button";
import EditText from "../ui/EditText";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-auto bg-[#1c233a]  ">
      <div className=" max-w-[1700px] mx-auto">
        <div className="relative w-auto h-auto">
          {/* Main content */}
          <div className="relative z-10 p-[20px] sm:p-[30px] xl:py-[40px]">
            <div className="ml-[0px] sm:ml-[40px] xl:ml-[54px]">
              <div className="flex flex-col lg:flex-row justify-between items-start gap-8 lg:gap-[84px]  w-auto">
                {/* Left Section - Company Info & Social */}
                <div className="flex flex-col gap-[12px] sm:gap-[18px] xl:gap-[24px] justify-start items-start w-auto lg:w-[30%]">
                  {/* Logo Section */}
                  <Link to="/" className="relative block">
                    <div className="flex xl:justify-start xl:items-center gap-[10px] w-full ">
                      <div className="flex justify-center items-center ">
                        <img
                          src="\assets\logoWhite.png"
                          alt="Company Logo"
                          className="hidden md:block xl:w-auto xl:h-auto"
                        />
                      </div>
                    </div>
                  </Link>
                  {/* Description */}
                  <p className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] xl:leading-[38px] text-left text-white font-[Sora] w-full">
                    symbol of trust, sustainability, and innovation in organic
                    agriculture—committed to nurturing the soil, empowering
                    farmers, and cultivating a greener, healthier future for
                    generations to come.
                  </p>

                  {/* Social Media Icons */}
                  <div className="flex gap-[10px] sm:gap-[15px] xl:gap-[20px] justify-start items-center w-auto">
                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]   border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Facebook"
                    >
                      <img
                        src="/assets/icon/faceBook.svg"
                        alt="Facebook"
                        className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                      />
                    </button>

                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]    border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="LinkedIn"
                    >
                      <img
                        src="/assets/icon/insta.svg"
                        alt="LinkedIn"
                        className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                      />
                    </button>
                    <button
                      className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px]    border  rounded-[50px]  flex items-center justify-center hover:opacity-80 transition-opacity"
                      aria-label="Instagram"
                    >
                      <img
                        src="/assets/icon/x.svg"
                        alt="Instagram"
                        className="w-[20px] h-[20px] sm:w-[25px] sm:h-[25px] xl:w-[24px] xl:h-[24px]"
                      />
                    </button>
                  </div>
                </div>

                {/* Right Section - Contact Details & Newsletter */}
                <div className="flex flex-wrap  justify-between lg:flex-nowrap gap-8 lg:gap-[50px] w-auto lg:w-auto">
                  {/* Contact Details */}

                  {/* Center Section - Quick Links */}
                  <div className="flex flex-col justify-start items-start w-auto lg:w-[20%]">
                    <h3 className="text-[16px] sm:text-[20px] xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora]">
                      Quick Links
                    </h3>
                    <a
                      href="/about"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora] mt-[12px] sm:mt-[18px] xl:mt-[24px] hover:opacity-75 transition-opacity"
                    >
                      About Us
                    </a>
                    <a
                      href="/products"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora] mt-[8px] sm:mt-[12px] xl:mt-[16px] hover:opacity-75 transition-opacity"
                    >
                      Products
                    </a>
                    <a
                      href="/blog"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora] mt-[10px] sm:mt-[15px] xl:mt-[20px] hover:opacity-75 transition-opacity"
                    >
                      Blog
                    </a>
                    <a
                      href="/contact-us"
                      className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora] mt-[7px] sm:mt-[10px] xl:mt-[14px] hover:opacity-75 transition-opacity"
                    >
                      Contact
                    </a>
                  </div>
                  <div className="flex flex-col gap-[11px] sm:gap-[16px] xl:gap-[22px] justify-start items-start w-auto lg:w-[40%]">
                    <h3 className="text-[16px] sm:text-[20px] xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora]">
                      Contact Details
                    </h3>

                    <ul className="flex flex-col justify-start items-start w-auto space-y-4">
                      <li>
                        <a
                          href="tel:+918645888881"
                          className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity"
                        >
                          <img
                            src="/assets/icon/call.svg"
                            alt="Phone"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px]"
                          />
                          <span className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora]">
                            +91 86 45 88 88 81
                          </span>
                        </a>
                      </li>
                      <li>
                        <a
                          href="mailto:info@utpann.in"
                          className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-center w-auto hover:opacity-75 transition-opacity mt-[12px] sm:mt-[18px] xl:mt-[24px]"
                        >
                          <img
                            src="/assets/icon/email.svg"
                            alt="Email"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px] self-start"
                          />
                          <span className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora]">
                            info@utpann.in
                          </span>
                        </a>
                      </li>
                      <li>
                        <div className="flex gap-[9px] sm:gap-[14px] xl:gap-[18px] justify-start items-start w-auto mt-[7px] sm:mt-[10px] xl:mt-[14px]">
                          <img
                            src="/assets/icon/location.svg"
                            alt="Address"
                            className="w-[15px] h-[15px] sm:w-[22px] sm:h-[22px] xl:w-[30px] xl:h-[30px]"
                          />
                          <p className="text-[16px] sm:text-[20px] xl:text-[24px] font-normal leading-[24px] sm:leading-[30px] xl:leading-[38px] text-left text-white font-[Sora] self-center w-[90%]">
                            Sr. No. 2373, Sim Vistar, At & Po-Pij, Ta-Vaso,
                            <br />
                            Dist-Nadiad, Gujarat 387230
                          </p>
                        </div>
                      </li>
                    </ul>
                  </div>

                  {/* Newsletter Subscription */}
                  <div className="flex flex-col gap-[10px] sm:gap-[15px] xl:gap-[20px] justify-start items-start w-auto lg:w-[30%]">
                    <h3 className="text-[16px] sm:text-[20px] xl:text-[24px] font-bold leading-[20px] sm:leading-[25px] xl:leading-[31px] text-left text-white font-[Sora]">
                      Subscribe to Our Newsletter
                    </h3>

                    <EditText
                      placeholder="Enter your mail"
                      text_font_size="14"
                      text_font_family="Sora"
                      text_font_weight="400"
                      text_line_height="18px"
                      text_text_align="center"
                      text_color="#ffffff7f"
                      border_border="1px solid #ffffff"
                      border_border_radius="rounded-full"
                      padding="7px 15px"
                      className="w-full text-[14px] sm:text-[17px] xl:text-[20px] leading-[18px] sm:leading-[22px] xl:leading-[26px] py-[7px] px-[15px] sm:py-[10px] sm:px-[22px] xl:py-[14px] xl:px-[30px]"
                    />

                    <Button
                      text="Subscribe"
                      text_font_size="16"
                      text_font_family="Sora"
                      text_font_weight="700"
                      text_line_height="20px"
                      text_text_align="center"
                      text_color="#7ABF6B"
                      fill_background_color="#7abf6b"
                      border_border_radius="rounded-full"
                      border_border="1px solid #7ABF6B"
                      padding="6px 17px"
                      className="w-auto text-[16px] sm:text-[20px] xl:text-[24px] leading-[20px] sm:leading-[25px] xl:leading-[31px] py-[6px] px-[17px] sm:py-[9px] sm:px-[25px] xl:py-[12px] xl:px-[34px]"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
